/* eslint-disable @typescript-eslint/naming-convention */
/**
 * Contacts.Api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type Gender = 'NA' | 'Male' | 'Female' | 'Third';

export const Gender = {
    NA: 'NA' as Gender,
    Male: 'Male' as Gender,
    Female: 'Female' as Gender,
    Third: 'Third' as Gender
};
